import { useParams } from "react-router";
import JobNewViewApplyMetricsChart from "../../../charts/jobNewViewApplyMetricsChart";
import OffersMade from "../parts/OffersMade";
import JobListingSocials from "../parts/JobListingSocials";
import JobCompletionStats from "../../JobCompletionsStats/JobCompletionStats";
// import { useJobDetailsNewCollection } from "../../../data/jobDetailsNewCollection";

function JobNewOverview() {
  const params = useParams();
  const jobId = params.id ?? "";
  // const { user } = useAuth();
  // const { data: job } = useJobDetailsNewCollection(jobId);

  return (
    <div className="w-full pb-36  pr-6 flex flex-col mt-5 gap-y-6">
     
     
      <div>
        <JobListingSocials id={jobId} />
      </div>
    

      <div>
        <JobNewViewApplyMetricsChart jobId={jobId} />
      </div>
    </div>
  );
}

export default JobNewOverview;
